const Utils = (function() {
    const isTouchScreen = (('createTouch' in document) || ('ontouchend' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
    const clickEvent = isTouchScreen ? 'touchstart' : 'click';
    const appHeight = () => {
        const header = document.getElementById('header');
        const footer = document.getElementById('footer');
        const doc = document.documentElement;

        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        doc.style.setProperty('--footer-height', null !== footer ? `${footer.offsetHeight}px` : '0px');
        doc.style.setProperty('--header-height', null !== header ? `${header.offsetHeight}px` : '0px');
    }
    window.addEventListener('resize', appHeight);
    window.addEventListener('load', appHeight);

    return {
        isTouchScreen: isTouchScreen,
        clickEvent: clickEvent,
        appHeight: appHeight
    }
})();
